
import { Currency } from '~/plugins/Currency'
export default {
  props: {
    product: {
      default: () => {},
    },
  },
  data() {
    return {
      showPayments: false,
    }
  },
  methods: {
    Currency,
  },
}
